import ExploreActionTypes from 'app/explore/ActionTypes';
import reducer from 'app/explore/reducer';
import routes from 'app/explore/routes';

export default {
  reducers: {
    explore: reducer,
  },
  actionTypes: ExploreActionTypes,
  routes,
};
